import React, { useEffect, useState, useRef, useCallback } from 'react';
import {
  Button, Form, FormGroup, Input, Row, Spinner,
  Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import { CustomForm } from 'components/Generic/CustomForm';
import { useForm } from 'react-hook-form';
import { Text } from 'components/Form/Fields';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import { TableGeneric } from '../Product/product';
import { handleSendGeneric } from 'services/generic';
import { Notification } from 'notification/notification';
import { useSale } from './sale-table-context';
import { convertBrl, convertToFloat, convertToFloatBr } from 'utility/generic';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import ModalDetails from '../modal';
import ComprovanteWhatsapp from './ComprovanteWhatsapp';
import { uploadWhatsappFile } from 'services/whatsapp';
import { WhatsappMessageModal } from '../Whatsapp/WhatsappMessageModal';
import html2canvas from 'html2canvas';
import localforage from 'localforage';
import { uuidv4 } from 'utility/generic';

const defaultQuantity = '1';

// Mesma lógica de cálculo do comprovante.js
function calcularTotais(productList, commission) {
  let totalGeral = 0;
  let totalGeralLiquido = 0;
  (productList || [])
    .filter((p) => p.type !== 'GIFT')
    .forEach((product) => {
      const valorUnitario = convertToFloatBr(product.value);
      const quantidade = parseFloat(product.quantity);
      const valorTotalProduto = valorUnitario * quantidade;
      totalGeral += valorTotalProduto;
      const valorTotalAPagar =
        valorTotalProduto - (valorTotalProduto * parseFloat(commission || 0)) / 100;
      totalGeralLiquido += valorTotalAPagar;
    });
  return { totalGeral, totalGeralLiquido };
}

export const ClientPreSaleForm = () => {
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState(null);
  const [quantity, setQuantity] = useState(defaultQuantity);
  const [options, setOptions] = useState([]);

  // Estado do preview e do modal WhatsApp
  const [previewOpen, setPreviewOpen] = useState(false);
  const [generatingPng, setGeneratingPng] = useState(false);
  const [whatsappModal, setWhatsappModal] = useState(false);
  const [whatsappClients, setWhatsappClients] = useState([]);
  const [prefilledAttachment, setPrefilledAttachment] = useState(null);
  const [saldoDevedor, setSaldoDevedor] = useState(0);

  const comprovanteRef = useRef(null);
  const history = useHistory();
  const { reset, getValues, control, setValue } = useForm({
    defaultValues: {
      id: null,
      client: null,
      total: 0,
      discount: 0,
      deleted: 0,
      productList: [],
    },
  });
  const { data, setData } = useSale();

  const columnsProduct = useMemo(
    () => [
      { Header: 'Nome',      accessor: 'name' },
      { Header: 'Valor',     accessor: 'value' },
      {
        Header: 'Quantidade',
        accessor: 'quantity',
        Cell: ({ row }) => {
          const [quantidade, setQuantidade] = useState(row.original.quantity);
          const onChange = (e) => {
            const value = e.target.value;
            const newQuantity = parseInt(value, 10);
            if (isNaN(newQuantity)) return;
            setQuantidade(newQuantity);
            setData((currentData) => {
              const nextData = [...currentData];
              nextData[row.index].quantity = newQuantity;
              nextData[row.index].stock.quantity = newQuantity;
              setValue('productList', nextData);
              return nextData;
            });
          };
          return (
            <Input
              className='form-control-alternative'
              id='input-first-name'
              size={'sm'}
              type='number'
              value={quantidade}
              onChange={onChange}
              min={0}
            />
          );
        },
      },
      {
        Header: 'Total',
        accessor: (row) =>
          convertBrl((convertToFloat(row.value) * row.quantity).toFixed(2)),
      },
      {
        Header: 'Ações',
        Cell: ({ row, rows }) => {
          const handleRemove = (e) => {
            e.preventDefault();
            setData((currentData) => {
              const nextData = [...currentData];
              nextData.splice(row.index, 1);
              setValue('productList', nextData);
              return nextData;
            });
            const index = rows.findIndex((r) => r.id === row.id);
            const newRows = [...rows];
            newRows.splice(index, 1);
            Notification(200, 'Produto removido com sucesso!');
          };
          return (
            <Button color='danger' onClick={handleRemove}>
              Remover
            </Button>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setData]
  );

  useEffect(() => {
    const { state, pathname } = location;
    if (!pathname.includes('new')) {
      const { client, total, discount, productList, id } = state;
      setValue('client', client);
      setValue('total', total);
      setValue('productList', productList);
      setValue('discount', discount);
      setValue('id', id);
      const productListConvert = productList.map((prod) => ({
        id: prod.id,
        quantity: prod.quantity,
        value: prod.stock.value,
        name: prod.stock.name,
      }));
      setData(() => [...productListConvert]);
    } else {
      setData(() => []);
      setValue('client', state);
    }

    async function getAllProducts() {
      const d = await handleSendGeneric('/v1/product', 'GET');
      setOptions(
        d.map((product) => ({
          label: `${product?.name} - Preço: ${product?.value} - Estoque: ${product?.quantity}`,
          value: product,
        }))
      );
    }
    getAllProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, setValue]);

  const handleIncludeProductFromSale = () => {
    const { value } = selectedOption;
    setData((currentData) => {
      const nextData = [...currentData];
      nextData.push({ ...value, id: null, quantity, stock: { ...value, quantity } });
      setValue('productList', nextData);
      return nextData;
    });
    setQuantity(defaultQuantity);
    Notification(200, 'Produto adicionado com sucesso!');
  };

  // Abre o modal de preview (sem gerar PNG ainda)
  const handleAbrirPreview = useCallback(async () => {
    if (whatsappClients.length === 0) {
      const clientsData = await handleSendGeneric('/v1/client', 'GET');
      setWhatsappClients(clientsData || []);
    }
    const client = getValues('client');
    if (client?.id) {
      const clientFull = await handleSendGeneric(`/v1/client/${client.id}`, 'GET');
      const stocks = clientFull?.stocks || [];
      const saldo = stocks.reduce((total, item) => total + convertToFloat(item.debtor || 0), 0);
      setSaldoDevedor(saldo);
    }
    setPreviewOpen(true);
  }, [whatsappClients, getValues]);

  // Gera PNG a partir do comprovante no modal de preview, faz upload e abre o modal WhatsApp
  const handleGerarEEnviar = useCallback(async () => {
    if (!comprovanteRef.current) return;
    setGeneratingPng(true);
    try {
      const canvas = await html2canvas(comprovanteRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#111111',
        logging: false,
      });
      const blob = await new Promise((res) => canvas.toBlob(res, 'image/png'));
      const client = getValues('client');
      const nomeCliente = (client?.name || 'cliente').replace(/[^a-zA-Z0-9]/g, '_').toLowerCase();
      const filename = `comprovante_${nomeCliente}.png`;
      const file = new File([blob], filename, { type: 'image/png' });

      if (!navigator.onLine) {
        // Salva o blob localmente para upload posterior na sincronização
        const localKey = `offline_attachment_${uuidv4()}`;
        const base64 = await new Promise((res) => {
          const reader = new FileReader();
          reader.onloadend = () => res(reader.result);
          reader.readAsDataURL(blob);
        });
        await localforage.setItem(localKey, { base64, filename, mimeType: 'image/png' });
        setPrefilledAttachment({ url: localKey, mimeType: 'image/png', filename, offline: true });
        setGeneratingPng(false);
        setPreviewOpen(false);
        setWhatsappModal(true);
        return;
      }

      const uploaded = await uploadWhatsappFile(file);
      if (!uploaded) { setGeneratingPng(false); return; }

      setPrefilledAttachment(uploaded);
      setGeneratingPng(false);
      setPreviewOpen(false);
      setWhatsappModal(true);
    } catch (err) {
      console.error(err);
      Notification(500);
      setGeneratingPng(false);
    }
  }, [getValues]);

  const handleWhatsappSave = async (payload) => {
    const { scheduleWhatsappMessage, sendWhatsappMessageNow } = await import('services/whatsapp');
    const { sendNow: immediate, ...rest } = payload;
    const result = await scheduleWhatsappMessage(rest);
    if (result) {
      if (immediate && result.status !== 'PENDING') await sendWhatsappMessageNow(result.id);
      setWhatsappModal(false);
      setPrefilledAttachment(null);
    }
  };

  const buildWhatsappInitialValues = () => {
    if (!prefilledAttachment) return undefined;
    const client = getValues('client');
    const { totalGeralLiquido } = calcularTotais(data, client?.commission);
    const valorFmt = convertBrl(totalGeralLiquido);
    return {
      clientId:            client?.id ? String(client.id) : '',
      clientName:          client?.name || '',
      messageBody:         `Olá ${client?.name || ''}, segue em anexo o comprovante da sua pré-venda no valor de ${valorFmt}. Qualquer dúvida, estamos à disposição!`,
      attachmentUrl:       prefilledAttachment.url,
      attachmentType:      prefilledAttachment.mimeType,
      attachmentName:      prefilledAttachment.filename,
      localAttachmentKey:  prefilledAttachment.offline ? prefilledAttachment.url : undefined,
    };
  };

  const client  = getValues('client');
  const { totalGeralLiquido } = calcularTotais(data, client?.commission);

  return (
    <>
      <CustomForm
        nameForm={'Pré-Venda'}
        typeForm={'POST'}
        pathUrl={'/v1/sale'}
        getValues={getValues}
        loadValues={reset}
        forceRefreshPage
        onlyReturnPage
      >
        <Form>
          <div className='pl-lg-4'>
            <Row>
              <Text control={control} label={'Razão Social'}  fieldName={'client.name'}       placeholder={'Informe a razão social'}         size={4} readOnly />
              <Text control={control} label={'Comissão'}      fieldName={'client.commission'}  placeholder={'Informe a comissão do cliente'}   size={2} readOnly />
              <Text control={control} label={'Cidade'}        fieldName={'client.city'}        placeholder={''}                               size={4} readOnly />
            </Row>

            <div style={{ paddingTop: '4%' }}>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <Button
                  color='info'
                  onClick={() => history.push('/admin/sale/execute-sale', getValues('client'))}
                >
                  Criar Venda
                </Button>
                <ModalDetails
                  buttonLabel={'Imprimir Pré-Venda'}
                  titleModal={'Pré-Venda'}
                  content={{ client: getValues('client'), productList: data }}
                  size={'md'}
                  message={'Cadastre os produtos antes de imprimir para ter todos os dados no comprovante.'}
                />
                <Button
                  onClick={handleAbrirPreview}
                  disabled={data.length === 0}
                  style={{ background: '#25D366', border: 'none', color: '#fff' }}
                >
                  Enviar via WhatsApp
                </Button>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '2%', alignItems: 'center' }}>
                <div style={{ width: '80%' }}>
                  <Select
                    defaultValue={selectedOption}
                    onChange={setSelectedOption}
                    options={options}
                    isSearchable
                    isClearable
                    placeholder='Selecione um produto'
                  />
                </div>
                <Text
                  placeholder={'Informe a quantidade'}
                  name={'Quantidade'}
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  size={2}
                />
                <Button color='success' onClick={handleIncludeProductFromSale}>
                  Adicionar
                </Button>
              </div>

              <TableGeneric columns={columnsProduct} data={data} disableGlobalFilter />

              <FormGroup>
                <label style={{ marginTop: '20px' }} className='form-control-label' htmlFor='input-total'>
                  Total
                </label>
                <Input
                  className='form-control-alternative'
                  id='input-total'
                  size='lg'
                  type='text'
                  value={convertBrl(data.reduce((sum, p) => sum + convertToFloat(p.value) * p.quantity, 0))}
                  readOnly
                />
              </FormGroup>
            </div>
          </div>
        </Form>
      </CustomForm>

      {/* ── Modal de Preview do Comprovante ── */}
      <Modal isOpen={previewOpen} toggle={() => setPreviewOpen(false)} size='lg' centered>
        <ModalHeader toggle={() => setPreviewOpen(false)}>
          Preview — Comprovante WhatsApp
        </ModalHeader>
        <ModalBody style={{ background: '#1a1a1a', padding: '24px', display: 'flex', justifyContent: 'center' }}>
          <ComprovanteWhatsapp
            ref={comprovanteRef}
            client={getValues('client')}
            productList={data}
            saldoDevedor={saldoDevedor}
          />
        </ModalBody>
        <ModalFooter>
          <div style={{ fontSize: '13px', color: '#6c757d', flex: 1 }}>
            Total líquido: <strong>{convertBrl(totalGeralLiquido)}</strong>
          </div>
          <Button color='secondary' onClick={() => setPreviewOpen(false)} disabled={generatingPng}>
            Fechar
          </Button>
          <Button
            onClick={handleGerarEEnviar}
            disabled={generatingPng}
            style={{ background: '#25D366', border: 'none', color: '#fff' }}
          >
            {generatingPng
              ? <><Spinner size='sm' className='mr-1' /> Gerando PNG...</>
              : 'Gerar PNG e Enviar'}
          </Button>
        </ModalFooter>
      </Modal>

      {/* ── Modal WhatsApp ── */}
      <WhatsappMessageModal
        isOpen={whatsappModal}
        toggle={() => { setWhatsappModal(false); setPrefilledAttachment(null); }}
        onSave={handleWhatsappSave}
        clients={whatsappClients}
        initialValues={buildWhatsappInitialValues()}
      />
    </>
  );
};
